import React, { useState, useRef, useEffect, useContext } from "react";
import ListInfo from "../../CouponCode/ListCouponCode.module.css";
import styles from "./StudentCouponCode.module.css";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../labels";
import { UserContext } from "../../../../../context/UserDetails";
import moment from "moment";

function StudentCouponCode() {
  let page = R_PER_PAGE;
  // use state
  const [rowsPerPage1, setRowsPerPage1] = useState(page);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState();
  const { logout } = useContext(UserContext);
  const filterRef = useRef(null);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    } else {
      logout();
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  useEffect(() => {
    loadListdata();
  }, []);

  //sorting function
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  //coupon list
  function loadListdata() {
    let statusFilter = {
      search: "",
      user_id: userid,
    };
    setIsLoading(true);
    AxiosInstance.post("/api/all/coupon/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setCurrentPage1(1);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  // total table data  with pages
  const totalPages1 = Math.ceil(updateListData?.length / rowsPerPage1);

  //coupon list
  const handlePrev1 = (val) => {
    setCurrentPage1(val);
  };
  const handleNext1 = (val) => {
    setCurrentPage1(val);
  };
  const handlePageCount1 = (e) => {
    setRowsPerPage1(Number(e.target.value));
    setCurrentPage1(1);
  };

  // pagination start end -   item per page changing
  const start1 = (currentPage1 - 1) * rowsPerPage1;
  const end1 = start1 + rowsPerPage1;
  const currentData1 = updateListData?.slice(start1, end1);

  const formatDate = (start_date, end_date) => {
    return `${moment(start_date).format("DD/MM/YYYY")} - ${moment(
      end_date
    ).format("DD/MM/YYYY")}`;
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid BathHeader  global_container p-0`}
    >
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Coupon Codes</h2>
      </div>

      <fieldset className="mt-3">
        <legend className="w-auto">Coupon Codes</legend>
        <div className="row mt-2 mx-0">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No. */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  {/* Course */}

                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "coupon_code")}
                    >
                      {" "}
                      Coupon Code
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "coupon_code")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "amount")}
                    >
                      {" "}
                      Amount
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "amount")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  <th id="th" ref={filterRef}>
                    <span className="textHead_th">Validity</span>
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "is_applied")}
                    >
                      {" "}
                      Status
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "is_applied")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData1?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData1?.map((course, index) => (
                    <tr key={index}>
                      <td id="td">{course.serialNumber}</td>
                      <td id="td">{course.coupon_code} </td>
                      <td id="td">{course.amount} </td>
                      <td id="td">
                        <span>
                          {formatDate(course.start_date, course.end_date)}
                        </span>
                      </td>

                      {course.is_applied == 0 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-green mx-0 ">
                            Applied
                          </span>
                        </td>
                      )}
                      {course.is_applied == 1 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-orange mx-0">
                            Not Yet Applied
                          </span>
                        </td>
                      )}

                      {course.is_applied == 2 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-danger mx-0 ">
                            Expired
                          </span>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage1}
            handlePageCount={handlePageCount1}
            startPage={
              updateListData && updateListData?.length > 0
                ? currentPage1 * rowsPerPage1 + 1 - rowsPerPage1
                : 0
            }
            endPage={
              updateListData && updateListData?.length > 0
                ? updateListData?.length < currentPage1 * rowsPerPage1
                  ? updateListData?.length
                  : currentPage1 * rowsPerPage1
                : 0
            }
            totalRecords={
              updateListData && updateListData?.length > 0
                ? updateListData?.length
                : 0
            }
            handlePrev={(e) => handlePrev1(currentPage1 - 1)}
            currentPrevPage={currentPage1 === 1}
            prevButton={`${ListInfo.prev_buttonViewEvaluator} ${ListInfo.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext1(currentPage1 + 1)}
            currentNextPage={currentPage1 === totalPages1}
          />
        </div>
      </fieldset>
    </div>
  );
}

export default StudentCouponCode;
